import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import usermanagementConstants from "../Constants/UsermanagementConstants";

let result = null;
let organisationList = [];
let addOrUpdateOrganisationResult = null;
let blockOrganisationResult = null;
let UnblockOrganisationResult = null;

let plantsList = [];
let addOrganisationAdminResult = null;
let addUserResult = null;
let blockUserResult = null;
let UnblockUserResult = null;
let filteredUserResult = [];
let roleList = [];
let addOrUpdateRoleResult = null;
let userRoleList = [];
let costCentreList = [];
let costCentreAddOrUpdateResult = null;
let costCentreForUserResult = null;
let deleteRoleForUserResult = null;
let deleteCostCentreForUserResult = null;

let deleteCostCenter = null;
let plantCostCenter = null;

let userPasswordResetResult = null;
let allocateEquipmentGroupPlant = null;
let usersByPlant = null;
let orgDomain = null;
let orgConfig = null;
let cloneOrgResult = null;
let responsibleUserList = [];
let equGrpUserList = [];
let addResponsibleUserResult = null;
let deleteResponsibleUserResult = null;
let getAdminOrPlantAdminPlantsRes = null;
let exportOrganisationDataResult = null;
let downloadOrganisationDataResult = null;
let getOrganisationExportDetails = null;
let exportArbeitsmittelgruppenResult = null;
let arbeitsmittelExportStatus = null;
let downloadArbeitsmittelExportResult = null;
class UsermanagementStore extends EventEmitter {
  getResult() {
    return result;
  }
  setResult(res) {
    result = res;
  }

  getAddOrUpdateOrganisationResult() {
    return addOrUpdateOrganisationResult;
  }

  setAddOrUpdateOrganisationResult(res) {
    addOrUpdateOrganisationResult = res;
  }

  getDeleteCostCenter() {
    return deleteCostCenter;
  }

  setDeleteCostCenter(res) {
    deleteCostCenter = res;
  }

  getPlantCostCenter() {
    return plantCostCenter;
  }

  setPlantCostCenter(res) {
    plantCostCenter = res;
  }

  getAddOrUpdateUser() {
    return addUserResult;
  }
  setAddOrUpdateUser(res) {
    addUserResult = res;
  }

  getOrganisatioList() {
    return organisationList;
  }
  setOrganisatioList(res) {
    organisationList = res;
  }

  getBlockOrganisationResult() {
    return blockOrganisationResult;
  }

  setBlockOrganisationResult(res) {
    blockOrganisationResult = res;
  }

  getUnBlockOrganisationResult() {
    return UnblockOrganisationResult;
  }

  setUnBlockOrganisationResult(res) {
    UnblockOrganisationResult = res;
  }

  getBlockUserResult() {
    return blockUserResult;
  }

  setBlockUserResult(res) {
    blockUserResult = res;
  }

  getUnBlockUserResult() {
    return UnblockUserResult;
  }

  setUnBlockUserResult(res) {
    UnblockUserResult = res;
  }

  getAddOrganisationAdminResult() {
    return addOrganisationAdminResult;
  }

  setAddOrganisationAdminResult(res) {
    addOrganisationAdminResult = res;
  }

  getPlantResult() {
    return plantsList;
  }

  setGetPlantResult(res) {
    plantsList = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  getFilteredUserResponse() {
    return filteredUserResult;
  }

  setFilteredUserResponse(res) {
    filteredUserResult = res;
  }

  getRoleResult() {
    return roleList;
  }

  setRoleResult(res) {
    roleList = res;
  }

  getAddOrUpdateRoleResult() {
    return addOrUpdateRoleResult;
  }

  setAddOrUpdateRoleResult(res) {
    addOrUpdateRoleResult = res;
  }

  getUserRoleListResult() {
    return userRoleList;
  }

  setUserRoleListResult(res) {
    userRoleList = res;
  }

  getCostCentreResult() {
    return costCentreList;
  }

  setCostCentreResult(res) {
    costCentreList = res;
  }

  getCostCentreAddOrUpdateResult() {
    return costCentreAddOrUpdateResult;
  }

  setCostCentreAddOrUpdateResult(res) {
    costCentreAddOrUpdateResult = res;
  }

  getCostCentreForUserResult() {
    return costCentreForUserResult;
  }

  setCostCentreForUserResult(res) {
    costCentreForUserResult = res;
  }

  getDeleteRoleForUserResult() {
    return deleteRoleForUserResult;
  }

  setDeleteRoleForUserResult(res) {
    deleteRoleForUserResult = res;
  }

  getDeleteCostCentreForUserResult() {
    return deleteCostCentreForUserResult;
  }

  setDeleteCostCentreForUserResult(res) {
    deleteCostCentreForUserResult = res;
  }

  getUserPasswordResetResult() {
    return userPasswordResetResult;
  }

  setUserPasswordResetResult(res) {
    userPasswordResetResult = res;
  }

  getAllocateEquipmentgrpPlantResult() {
    return allocateEquipmentGroupPlant;
  }

  setAllocateEquipmentgrpPlantResult(res) {
    allocateEquipmentGroupPlant = res;
  }

  getUsersByResult() {
    return usersByPlant;
  }
  setUsersByResult(res) {
    usersByPlant = res;
  }

  getOrgDomain() {
    return orgDomain;
  }
  setOrgDomain(res) {
    orgDomain = res;
  }

  getOrgConfig() {
    return orgConfig;
  }
  setOrgConfig(res) {
    orgConfig = res;
  }

  getCloneOrgResult() {
    return cloneOrgResult;
  }
  setCloneOrgResult(res) {
    cloneOrgResult = res;
  }

  getResponsibleUserList() {
    return responsibleUserList;
  }

  setResponsibleUserList(res) {
    responsibleUserList = res;
  }

  getEqupGrpUserList() {
    return equGrpUserList;
  }

  setEqupGrpUserList(res) {
    equGrpUserList = res;
  }

  getAddResponsibleUserRes() {
    return addResponsibleUserResult;
  }

  setAddResponsibleUserRes(res) {
    addResponsibleUserResult = res;
  }

  getDeleteResponsibleUserRes() {
    return deleteResponsibleUserResult;
  }

  setDeleteResponsibleUserRes(res) {
    deleteResponsibleUserResult = res;
  }

  getAdminOrPlantAdminPlantsRes() {
    return getAdminOrPlantAdminPlantsRes;
  }

  setAdminOrPlantAdminPlantsRes(res) {
    getAdminOrPlantAdminPlantsRes = res;
  }

  getExportOrganisationDataResult() {
    return exportOrganisationDataResult;
  }

  setExportOrganisationDataResult(res) {
    exportOrganisationDataResult = res;
  }

  getDownloadOrganisationDataResult() {
    return downloadOrganisationDataResult;
  }

  setDownloadOrganisationDataResult(res) {
    downloadOrganisationDataResult = res;
  }

  getOrganisationExportDetails() {
    return getOrganisationExportDetails;
  }

  setOrganisationExportDetails(res) {
    getOrganisationExportDetails = res;
  }

  getExportArbeitsmittelgruppenResult() {
    return exportArbeitsmittelgruppenResult;
  }

  setExportArbeitsmittelgruppenResult(res) {
    exportArbeitsmittelgruppenResult = res;
  }

  getArbeitsmittelExportStatus() {
    return arbeitsmittelExportStatus;
  }

  setArbeitsmittelExportStatus(res) {
    arbeitsmittelExportStatus = res;
  }

  getDownloadArbeitsmittelExportResult() {
    return downloadArbeitsmittelExportResult;
  }

  setDownloadArbeitsmittelExportResult(res) {
    downloadArbeitsmittelExportResult = res;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case usermanagementConstants.GET_USERS_SUCESS:
        this.setResult(action.result);
        break;
      case usermanagementConstants.GET_USERS_FAILURE:
        this.setResult(null);
        break;
      case usermanagementConstants.ADDORUPDATE_ORGANISATION_SUCCESS:
        this.setAddOrUpdateOrganisationResult(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_ORGANISATION_FAILURE:
        this.setAddOrUpdateOrganisationResult(action.result);
        break;
      case usermanagementConstants.GET_ORGANISATION_SUCCESS:
        this.setOrganisatioList(action.result);
        break;
      case usermanagementConstants.GET_ORGANISATION_FAILURE:
        this.setOrganisatioList([]);
        break;
      case usermanagementConstants.BLOCK_ORGANISATION_SUCCESS:
        this.setBlockOrganisationResult(action.result);
        break;
      case usermanagementConstants.BLOCK_ORGANISATION_FAILURE:
        this.setBlockOrganisationResult(action.result);
        break;
      case usermanagementConstants.UNBLOCK_ORGANISATION_SUCCESS:
        this.setUnBlockOrganisationResult(action.result);
        break;
      case usermanagementConstants.UNBLOCK_ORGANISATION_FAILURE:
        this.setUnBlockOrganisationResult(action.result);
        break;

      case usermanagementConstants.GET_PLANT_SUCCESS:
        this.setGetPlantResult(action.result);
        break;
      case usermanagementConstants.GET_PLANT_FAILURE:
        this.setGetPlantResult(action.result);
        break;
      case usermanagementConstants.ADD_ORGANISATION_ADMIN_SUCCESS:
        this.setAddOrganisationAdminResult(action.result);
        break;
      case usermanagementConstants.ADD_ORGANISATION_ADMIN_FAILURE:
        this.setAddOrganisationAdminResult(action.result);
        break;
      case usermanagementConstants.BLOCK_USER_SUCCESS:
        this.setBlockUserResult(action.result);
        break;
      case usermanagementConstants.BLOCK_USER_FAILURE:
        this.setBlockUserResult(action.result);
        break;
      case usermanagementConstants.UNBLOCK_USER_SUCCESS:
        this.setUnBlockUserResult(action.result);
        break;
      case usermanagementConstants.UNBLOCK_USER_FAILURE:
        this.setUnBlockUserResult(action.result);
        break;
      case usermanagementConstants.GET_FILTERED_USER_SUCCESS:
        this.setFilteredUserResponse(action.result);
        break;
      case usermanagementConstants.GET_FILTERED_USER_FAILURE:
        this.setFilteredUserResponse(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_USER_SUCCESS:
        this.setAddOrUpdateUser(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_USER_FAILURE:
        this.setAddOrUpdateUser(action.result);
        break;
      case usermanagementConstants.GET_ROLE_SUCCESS:
        this.setRoleResult(action.result);
        break;
      case usermanagementConstants.GET_ROLE_FAILURE:
        this.setRoleResult(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_ROLE_SUCCESS:
        this.setAddOrUpdateRoleResult(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_ROLE_FAILURE:
        this.setAddOrUpdateRoleResult(action.result);
        break;
      case usermanagementConstants.GET_USER_ROLE_SUCCESS:
        this.setUserRoleListResult(action.result);
        break;
      case usermanagementConstants.GET_USER_ROLE_FAILURE:
        this.setUserRoleListResult(action.result);
        break;
      case usermanagementConstants.GET_COST_CENTRE_SUCCESS:
        this.setCostCentreResult(action.result);
        break;
      case usermanagementConstants.GET_COST_CENTRE_FAILURE:
        this.setCostCentreResult(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_COST_CENTRE_SUCCESS:
        this.setCostCentreAddOrUpdateResult(action.result);
        break;
      case usermanagementConstants.ADDORUPDATE_COST_CENTRE_FAILURE:
        this.setCostCentreAddOrUpdateResult(action.result);
        break;
      case usermanagementConstants.GET_COST_CENTRE_FOR_USER_SUCCESS:
        this.setCostCentreForUserResult(action.result);
        break;
      case usermanagementConstants.GET_COST_CENTRE_FOR_USER_FAILURE:
        this.setCostCentreForUserResult(action.result);
        break;
      case usermanagementConstants.DELETE_ROLE_FOR_USER_SUCCESS:
        this.setDeleteRoleForUserResult(action.result);
        break;
      case usermanagementConstants.DELETE_ROLE_FOR_USER_FAILURE:
        this.setDeleteRoleForUserResult(action.result);
        break;
      case usermanagementConstants.DELETE_COST_CENTRE_FOR_USER_SUCCESS:
        this.setDeleteCostCentreForUserResult(action.result);
        break;
      case usermanagementConstants.DELETE_COST_CENTRE_FOR_USER_FAILURE:
        this.setDeleteCostCentreForUserResult(action.result);
        break;

      case usermanagementConstants.DELETE_COST_CENTER_SUCCESS:
        this.setDeleteCostCenter(action.result);
        break;
      case usermanagementConstants.DELETE_COST_CENTER_FAILURE:
        this.setDeleteCostCenter(action.result);
        break;
      case usermanagementConstants.GET_PLANT_COST_CENTER_SUCCESS:
        this.setPlantCostCenter(action.result);
        break;
      case usermanagementConstants.GET_PLANT_COST_CENTER_FAILURE:
        this.setPlantCostCenter(action.result);
        break;
      case usermanagementConstants.RESET_USER_PASSWORD_SUCCESS:
        this.setUserPasswordResetResult(action.result);
        break;
      case usermanagementConstants.RESET_USER_PASSWORD_FAILURE:
        this.setUserPasswordResetResult(action.result);
        break;
      case usermanagementConstants.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_SUCCESS:
        this.setAllocateEquipmentgrpPlantResult(action.result);
        break;
      case usermanagementConstants.GET_ALLOCATE_PLANT_EQUIPMENT_GROUP_FAILURE:
        this.setAllocateEquipmentgrpPlantResult(action.result);
        break;
      case usermanagementConstants.GET_PLANT_USER_SUCCESS:
        this.setUsersByResult(action.result);
        break;
      case usermanagementConstants.GET_PLANT_USER_FAILURE:
        this.setUsersByResult(action.result);
        break;
      case usermanagementConstants.GET_ORG_DOMAN_SUCCESS:
        this.setOrgDomain(action.result);
        break;
      case usermanagementConstants.GET_ORG_DOMAN_FAILURE:
        this.setOrgDomain(action.result);
        break;
      case usermanagementConstants.GET_ORG_CONFIG_SUCCESS:
        this.setOrgConfig(action.result);
        break;
      case usermanagementConstants.GET_ORG_CONFIG_FAILURE:
        this.setOrgConfig(action.result);
        break;
      case usermanagementConstants.CLONE_ORGANISATION_SUCCESS:
        this.setCloneOrgResult(action.result);
        break;
      case usermanagementConstants.CLONE_ORGANISATION_FAILURE:
        this.setCloneOrgResult(action.result);
        break;
      case usermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS:
        this.setResponsibleUserList(action.result);
        break;
      case usermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE:
        this.setResponsibleUserList(action.result);
        break;
      case usermanagementConstants.GET_EQUIP_GRP_USER_SUCCESS:
        this.setEqupGrpUserList(action.result);
        break;
      case usermanagementConstants.GET_EQUIP_GRP_USER_FAILURE:
        this.setEqupGrpUserList(action.result);
        break;
      case usermanagementConstants.ADD_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS:
        this.setAddResponsibleUserRes(action.result);
        break;
      case usermanagementConstants.ADD_EQUIP_GRP_RESPONSIBLE_USER_FAILURE:
        this.setAddResponsibleUserRes(action.result);
        break;
      case usermanagementConstants.DELETE_RESPONSIBLE_USER_SUCCESS:
        this.setDeleteResponsibleUserRes(action.result);
        break;
      case usermanagementConstants.DELETE_RESPONSIBLE_USER_FAILURE:
        this.setDeleteResponsibleUserRes(action.result);
        break;
      case usermanagementConstants.GET_ADMIN_OR_PLANT_ADMIN_PLANT_SUCCESS:
        this.setAdminOrPlantAdminPlantsRes(action.result);
        break;
      case usermanagementConstants.GET_ADMIN_OR_PLANT_ADMIN_PLANT_FAILURE:
        this.setAdminOrPlantAdminPlantsRes(action.result);
        break;
      case usermanagementConstants.EXPORT_ORGANISATION_DATA_SUCCESS:
        this.setExportOrganisationDataResult(action.result);
        break;
      case usermanagementConstants.EXPORT_ORGANISATION_DATA_FAILURE:
        this.setExportOrganisationDataResult(action.result);
        break;
      case usermanagementConstants.DOWNLOAD_ORGANISATION_DATA_SUCCESS:
        this.setDownloadOrganisationDataResult(action.result);
        break;
      case usermanagementConstants.DOWNLOAD_ORGANISATION_DATA_FAILURE:
        this.setDownloadOrganisationDataResult(action.result);
        break;
      case usermanagementConstants.GET_ORGANISATION_EXPORT_DETAILS_SUCCESS:
        this.setOrganisationExportDetails(action.result);
        break;
      case usermanagementConstants.GET_ORGANISATION_EXPORT_DETAILS_FAILURE:
        this.setOrganisationExportDetails(action.result);
        break;
      case usermanagementConstants.EXPORT_ARBEITSMITTELGRUPPEN_SUCCESS:
        this.setExportArbeitsmittelgruppenResult(action.result);
        break;
      case usermanagementConstants.EXPORT_ARBEITSMITTELGRUPPEN_FAILURE:
        this.setExportArbeitsmittelgruppenResult(action.result);
        break;
      case usermanagementConstants.GET_ARBEITSMITTEL_EXPORT_STATUS_SUCCESS:
        this.setArbeitsmittelExportStatus(action.result);
        break;
      case usermanagementConstants.GET_ARBEITSMITTEL_EXPORT_STATUS_FAILURE:
        this.setArbeitsmittelExportStatus(action.result);
        break;
      case usermanagementConstants.DOWNLOAD_ARBEITSMITTEL_EXPORT_SUCCESS:
        this.setDownloadArbeitsmittelExportResult(action.result);
        break;
      case usermanagementConstants.DOWNLOAD_ARBEITSMITTEL_EXPORT_FAILURE:
        this.setDownloadArbeitsmittelExportResult(action.result);
        break;

      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const usermanagementStore = new UsermanagementStore();
dispatcher.register(
  usermanagementStore.handleCallback.bind(usermanagementStore)
);
export default usermanagementStore;
